export const TENANT_FEATURES = {
  // Core modules
  dashboard: { key: 'dashboard', label: 'Dashboard', default: true },
  field: { key: 'field', label: 'Campo & Lotes', default: true },
  tasks: { key: 'tasks', label: 'Tareas', default: true },
  chat: { key: 'chat', label: 'Chat IA', default: true },

  // Management
  finance: { key: 'finance', label: 'Finanzas', default: true },
  users: { key: 'users', label: 'Gestión de Usuarios', default: true },
  settings: { key: 'settings', label: 'Configuración', default: true },

  // Operations
  irrigation: { key: 'irrigation', label: 'Riego & Fertirrigación', default: true },
  harvest: { key: 'harvest', label: 'Cosecha & Empaque', default: true },
  inventory: { key: 'inventory', label: 'Inventario & Bodega', default: true },
  machinery: { key: 'machinery', label: 'Maquinaria', default: true },
  spray: { key: 'spray', label: 'Fitosanitario (Plagas)', default: true },

  // Advanced
  merma: { key: 'merma', label: 'Merma (Pérdidas)', default: true },
  crop: { key: 'crop', label: 'Cultivo & Fenología', default: true },
  payroll: { key: 'payroll', label: 'Nómina', default: true },
  porcino: { key: 'porcino', label: 'Módulo Porcino', default: false },

  // Export & Logistics
  export: { key: 'export', label: 'Exportación', default: true },
  transport: { key: 'transport', label: 'Transporte', default: true },
  traceability: { key: 'traceability', label: 'Trazabilidad', default: true },

  // Others
  map: { key: 'map', label: 'Mapa GIS', default: true },
  reports: { key: 'reports', label: 'Reportes', default: true },
  protocol: { key: 'protocol', label: 'Protocolos de Insumos', default: true },
  bulkImport: { key: 'bulkImport', label: 'Carga Masiva', default: false },

  // Asistencia por rostro (apagada por defecto; spec 2026-10-31-asistencia-por-rostro-design.md)
  attendance: { key: 'attendance', label: 'Asistencia por rostro', default: false },
  attendanceRotation: { key: 'attendanceRotation', label: 'Asistencia: rotación y pre-baja', default: false },
  // Apagador: la caseta sigue encendida salvo que se desactive aquí (sin QR en la Mini App ni vista web).
  attendanceGate: { key: 'attendanceGate', label: 'Asistencia: caseta de vigilancia', default: true },
  attendanceLive: { key: 'attendanceLive', label: 'Asistencia: nombres en vivo', default: false },
} as const;

export type TenantFeatureKey = keyof typeof TENANT_FEATURES;

export const getFeatureLabel = (key: string): string => {
  const feature = Object.values(TENANT_FEATURES).find(f => f.key === key);
  return feature?.label || key;
};

export const getDefaultPermissions = (): Record<string, boolean> => {
  const defaults: Record<string, boolean> = {};
  Object.values(TENANT_FEATURES).forEach(feature => {
    defaults[feature.key] = feature.default;
  });
  return defaults;
};
